// extracted by mini-css-extract-plugin
export default {"centered":"TaskWorklistsPage-styles-module--centered--dvCQf"};